<!-- 设备管理-设备列表页面 -->
<template>
  <div class="vcnDeviceList">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <div class="left_title">设备信息</div>
        <div class="device-tab">
          <div
            v-for="item in calType.column"
            :key="item.typeId"
            :class="['tab', type.prop == item.prop ? 'active' : '']"
            @click="handleChange(item)"
          >
            {{ item.label }}
          </div>
        </div>
        <!-- <ioc-tab-group :option="calType"
                       @change="handleChange"></ioc-tab-group> -->
        <div v-if="type.prop === 'tab1'" class="left-type_area">
          <ele-group-tree
            @getCode="getDeviceWrokGroupCode"
            @sendData="getDeviceTreeData"
            :deviceType="checkDevType"
            :paramsType="paramsType"
            @refresh="initGet()"
          ></ele-group-tree>
        </div>
        <div v-else-if="type.prop === 'tab2'" class="left-type_area sbar">
          <div class="device-search">
            <el-input
              placeholder="请输入搜索关键字"
              prefix-icon="el-icon-search"
              v-model="searchString"
              clearable
            >
            </el-input>
          </div>
          <el-scrollbar class="flex-auto" style="height: calc(100% - 50px)">
            <el-tree
              ref="tree"
              class="mb20"
              :data="areaTreeData"
              :highlight-current="true"
              :default-expand-all="true"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
            >
              <template slot-scope="{ node }">
                <element-tree-line
                  :node="node"
                  :showLabelLine="true"
                  :indent="16"
                  class="tree-line"
                >
                  <span class="custom-tree-node" style="display: block">
                    <i class="el-icon-document"></i>
                    <span style="margin-left: 3px">{{ node.label }}</span>
                  </span>
                </element-tree-line>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar flex-row">
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-iconfontfanhui"
            @click="retBtn"
            >{{ $t("cameraList.button.back") }}</el-button
          >
          <el-button
            type="primary"
            v-auth="'/device:move'"
            class="iss-operation-button"
            icon="iconfont icon-jinru"
            @click="moveIn"
            >{{ $t("cameraList.button.moveInto") }}</el-button
          >
        </div>
        <!-- 搜索框部分 -->

        <!-- <div class="section-main__filter"> -->
        <!-- 按照设备划分 -->
        <!-- <el-row>
            <el-form
              label-width="90px"
              label-position="left"
              :inline="true"
              size="small"
              class="demo-form-inline"
            >
              <el-col :span="5">
                <el-form-item label="消防车名称">
                  <el-input
                    v-model="searchForm.deviceName"
                    clearable
                    placeholder="消防车名称"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="车牌号">
                  <el-input
                    v-model="searchForm.plateNo"
                    clearable
                    placeholder="车牌号"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="5">
                <el-form-item label="唯一标识号">
                  <el-input
                    v-model="searchForm.thirdDeviceId"
                    clearable
                    placeholder="唯一标识号"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="queryDevList">{{
                  $t("cameraList.button.search")
                }}</el-button>
                <el-button type="info" @click="resetQuery">{{
                  $t("cameraList.button.reset")
                }}</el-button>
              </el-col>
            </el-form>
          </el-row> -->
        <!-- <template v-if="devTypeSer">
            <el-checkbox v-model="checkedDevice" @change="checkedDeviceState"
              >仅显示无设备组设备</el-checkbox
            >
          </template> -->
        <!-- </div> -->
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="devTab"
            :data="tableData"
            :option="calMetOption"
            :page="page"
            @selection-change="selectionChange"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <template slot="search_check" v-if="devTypeSer">
              <el-checkbox v-model="checkedDevice" @change="checkedDeviceState"
                >无设备组设备</el-checkbox
              >
            </template>
            <!-- 定制操作栏按钮 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('cameraList.label.viewDetail')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  class="el-icon-document"
                  @click="seeDel(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
            <!-- 表格列 自定义 -->
            <template slot="status" slot-scope="scope">
              <div>
                <span :style="{ color: color[scope.row.status] }" class="mr5">{{
                  scope.row.status == "1" ? "在线" : "离线"
                }}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="更新状态"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    @click="queryDeviceStatus(scope.row)"
                    class="iconfont-lunan icon-lunan-refresh"
                  ></el-button>
                </el-tooltip>
              </div>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic, Cache, Dates } from "$utils";
import { tableOption } from "../const/fireTruck";
import eleGroupTree from "../components/equipmentGroupTree";
import ElementTreeLine from "element-tree-line";
export default {
  components: {
    eleGroupTree,
    ElementTreeLine
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      checkedDevice: false,
      devTypeSer: true,
      disabled: false,
      color: {
        1: "#00e8bb",
        0: "red"
      },
      //摄像机分类方式
      type: {
        label: this.$t("cameraList.label.deviceSet"),
        prop: "tab1"
      },
      calType: {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1"
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2"
          }
        ]
      },
      // 区域树对象
      areaTreeData: [],
      // 设备组树对象
      deviceTreeData: [],
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName"
      },
      calMetOption: tableOption(this),
      tableData: [],
      // 分页属性设置
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      // 判断是否勾选查询无设备组
      isDeviceWorkGroup: "",
      // 左侧列表设备类型选中值
      checkDevType: "",
      deviceWorkGroupCode: "",
      areaDevGroupCode: "",
      searchForm: {
        deviceName: "",
        plateNo: "",
        thirdDeviceId: ""
      },
      paramsType: "",
      // 选中的设备ID
      selDev: [],
      selThirdDev: [],
      selectedDevs: [],
      searchString: ""
    };
  },
  created() {
    // 请求全量数据
    this.initGet();
    this.getAreaTree();
    this.type = this.calType.column[0];
  },
  mounted() {
    if (this.$route.query.device) {
      this.cacheRouterInfo = this.$route.query.device;
    }
  },
  destroyed() {
    Cache.remove("deviceTypeName");
    Cache.remove("deviceTypeId");
  },
  methods: {
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.areaDevGroupName.indexOf(value) !== -1;
    },
    // 请求消防车设备列表
    getDevList() {
      const params = {
        area: this.areaDevGroupCode,
        deviceName: this.searchForm.deviceName,
        deviceWorkGroupCode:
          this.deviceWorkGroupCode !== "" ? this.deviceWorkGroupCode : "",
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        plateNo: this.searchForm.plateNo,
        thirdDeviceId: this.searchForm.thirdDeviceId
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$fetch(api.fireTruck.queryFireTruckDeviceList, params).then(
        (res) => {
          setTimeout(() => {
            loading.close();
          }, 500);
          if (res.success) {
            this.tableData = res.returnObj.list;
            this.page.total = res.returnObj.total;
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },
    // 设备类型查询按钮查询设备列表
    queryDevList() {
      this.tableData = [];
      this.page.pageNum = 1;
      this.getDevList();
    },
    resetQuery() {
      this.deviceWorkGroupCode == "";
      this.isDeviceWorkGroup = "";
      this.areaDevGroupCode = "";
      this.searchForm = {
        deviceName: "",
        plateNo: "",
        thirdDeviceId: ""
      };
      this.getDevList();
    },
    //显示无设备组设备选中事件
    checkedDeviceState() {
      this.page.pageNum = 1;
      this.deviceWorkGroupCode = "";
      if (this.checkedDevice) {
        this.isDeviceWorkGroup = "1";
      } else {
        this.isDeviceWorkGroup = "";
      }
      this.getDevList();
    },

    getAreaTree() {
      this.$fetch(api.deviceMan.queryAssociationalDeviceTree).then((res) => {
        this.areaTreeData = res.returnObj;
      });
    },
    getDeviceTreeData(data) {
      this.deviceTreeData = data;
    },

    // 查看详情按钮
    seeDel(row) {
      this.$refs.devTab.rowView(row);
    },
    // 树节点点击事件
    handleNodeClick(data) {
      this.areaDevGroupCode = data.areaDevGroupCode;
      this.getDevList();
    },

    // 分页事件
    selectPage(val) {
      this.$refs.devTab.selectClear();
      this.page.pageNum = val;
      this.getDevList();
    },
    changeSize(val) {
      this.page.pageSize = val;
      this.page.pageNum = 1;
      this.getDevList();
    },
    // 切换左侧选项卡
    handleChange(column) {
      this.type = column;
      // 切换选项卡重置所有搜索条件
      this.isDeviceWorkGroup = "";
      this.checkedDevice = false;
      this.areaDevGroupCode = "";
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.initGet();
      if (this.type.prop === "tab1") {
        // 切换头部搜索条件
        this.devTypeSer = true;
      } else if (this.type.prop === "tab2") {
        this.devTypeSer = false;
      }
    },
    setCheckDevType() {
      if (this.$route.query.device.deviceTypeId) {
        this.checkDevType = this.$route.query.device.deviceTypeId;
        Cache.put("deviceTypeId", this.$route.query.device.deviceTypeId);
        this.paramsType = this.$route.query.device.deviceType;
      } else {
        this.checkDevType = Cache.get("deviceTypeId");
      }
    },
    // 初始化查询条件，查询全量数据；
    initGet() {
      this.setCheckDevType();
      this.getDevList();
    },
    retBtn() {
      this.$router.push({
        path: "/cameralist/devicelist",
        name: "devicelist",
        query: { device: this.routerObj }
      });
    },
    getDeviceWrokGroupCode(code) {
      this.deviceWorkGroupCode = code;
      this.initGet();
    },
    // 勾选事件
    selectionChange(selections) {
      if (selections.length < this.page.pageSize && selections.length > 0) {
        setTimeout(() => {
          $(".el-table__fixed-header-wrapper label.el-checkbox>span").attr(
            "class",
            "el-checkbox__input is-indeterminate"
          );
        }, 200);
      }
      this.selDev = [];
      this.selThirdDev = [];
      this.selectedDevs = selections;
      selections.map((item) => {
        this.selDev.push(item.deviceId);
        this.selThirdDev.push(item.thirdDeviceId);
      });
    },
    //挪入
    moveIn() {
      if (this.selDev.length <= 0) {
        this.$message({
          message: this.$t("cameraList.message.chooseEnter"),
          type: "warning"
        });
        return;
      }
      this.slectedAreaNode = "";
      this.deviceTreeShow = true;
      this.getAreaTree();
    },
    // 设备状态更新
    queryDeviceStatus(row) {
      this.$fetch(api.queryDeviceStatus, { deviceId: row.deviceId }).then(
        (res) => {
          if (res.success) {
            this.$message.success(res.msgContent);
            this.getDevList();
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    }
  }
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.vcnDeviceList {
  width: 100%;
  height: 100%;
  .devTyList {
    padding: 3px 10px;
    margin: 5px 10px;
    cursor: pointer;
  }
  .left_title {
    border-left: 4px solid #407aee;
    padding-left: 8px;
    margin: 16px;
  }
  .device-tab {
    display: flex;
    margin: 0 16px 0px 16px;
    .tab {
      color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #707070;
      &:hover {
        color: #fff;
        cursor: pointer;
      }
    }
    .active {
      color: #fff;
      border-color: #407aee;
    }
  }
  .device-search {
    display: flex;
    margin: 15px 16px;
    height: 28px;
    .el-input {
      width: 100%;
    }
  }
  .devTyListCheck {
    @include set_theme_color(background-color, page-bg-color);
  }
  .left-type_area {
    flex: 1;
    overflow: hidden;
  }
  .el-dialog__footer {
    padding: 20px;
    padding-top: 10px;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .upload-demo {
    margin: 0 10px;
  }

  .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
  .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 10px;
  }
}
.el-select {
  width: 100%;
}
</style>
